import React from 'react';
import { Modal } from '@trackman/web-shared-components';
import styled from 'styled-components';

export const LoadingModalWrapper = styled((props) => <Modal {...props} />)`
  text-align: center;
  .header {
    .close {
      display: none;
    }
  }
`;

export const ContentWrapper = styled.div`
  padding: 20px !important;
`;

export const IconAndTextRow = styled.div`
  display: flex;
  justify-content: center;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
`;

export const Text = styled.div`
  font-family: Lato;
  font-size: 15px;
`;
